import {useCallback, useMemo} from "react";
import {useHistory, useLocation} from "react-router";

const LOCATION_PARAM = "lokalizacja";
const TYPE_PARAM = "typ";

interface IUpdateUrlParamsInput {
    lokalizacja: string | null;
    typ: string | null;
}

export const useUpdateUrlParams = () => {
    const history = useHistory();
    const location = useLocation();
    const searchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);

    const updateUrlParams = useCallback(
        (params: IUpdateUrlParamsInput) => {
            const newSearchParams = new URLSearchParams();

            if (params.lokalizacja) {
                newSearchParams.set(LOCATION_PARAM, params.lokalizacja);
            }

            if (params.typ) {
                newSearchParams.set(TYPE_PARAM, params.typ);
            }

            searchParams.forEach((value, key) => {
                if (key !== LOCATION_PARAM && key !== TYPE_PARAM) {
                    newSearchParams.set(key, value);
                }
            });

            history.push({search: newSearchParams.toString()});
        },
        [history, searchParams]
    );

    return {updateUrlParams};
};
import {useCallback, useMemo} from "react";
import {useHistory, useLocation} from "react-router";

const LOCATION_PARAM = "lokalizacja";
const TYPE_PARAM = "typ";

interface IUpdateUrlParamsInput {
    lokalizacja: string | null;
    typ: string | null;
}

export const useUpdateUrlParams = () => {
    const history = useHistory();
    const location = useLocation();
    const searchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);

    const updateUrlParams = useCallback(
        (params: IUpdateUrlParamsInput) => {
            const newSearchParams = new URLSearchParams();

            if (params.lokalizacja) {
                newSearchParams.set(LOCATION_PARAM, params.lokalizacja);
            }

            if (params.typ) {
                newSearchParams.set(TYPE_PARAM, params.typ);
            }

            searchParams.forEach((value, key) => {
                if (key !== LOCATION_PARAM && key !== TYPE_PARAM) {
                    newSearchParams.set(key, value);
                }
            });

            history.push({search: newSearchParams.toString()});
        },
        [history, searchParams]
    );

    return {updateUrlParams};
};
